var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-section",style:(_vm.sectionStyle),attrs:{"id":_vm.id}},[_c('div',{staticClass:"default-section__container"},[_vm._t("title"),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }